/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ParamedicHospitalAssociation from './paramedic-hospital-association';
import ParamedicHospitalAssociationDetail from './paramedic-hospital-association-detail';
import ParamedicHospitalAssociationUpdate from './paramedic-hospital-association-update';
import ParamedicHospitalAssociationDeleteDialog from './paramedic-hospital-association-delete-dialog';

const ParamedicHospitalAssociationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ParamedicHospitalAssociation />} />
    <Route path="new" element={<ParamedicHospitalAssociationUpdate />} />
    <Route path=":id">
      <Route index element={<ParamedicHospitalAssociationDetail />} />
      <Route path="edit" element={<ParamedicHospitalAssociationUpdate />} />
      <Route path="delete" element={<ParamedicHospitalAssociationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ParamedicHospitalAssociationRoutes;
